<template>
    <div class="container">
        <content-header title="Программы медицинского обслуживания"/>

        <p><strong>Мы предлагаем различные варианты медицинского обслуживания сотрудников Вашей Компании.</strong></p>

        <p><strong>При формировании индивидуального пакета медицинских услуг учитываются особенности деятельности Вашей
            организации и потребности в медицинских услугах.</strong></p>

        <p><strong>Наши специалисты помогут в выборе наиболее оптимальной программы медицинского обслуживания для Вашего
            коллектива:</strong></p>
        <p class="bold">•Медицинские услуги с оплатой по факту</p>
        <div class="left-1em">
            <p>
                При заключение договора с оплатой по факту стоимость обслуживания будет зависеть от объема полученных
                Вашими сотрудниками медицинских услуг. Обслуживание пациентов реализуется как по программам Поликлиники,
                так
                и по партнерским программам.
            </p>
        </div>
        <p class="bold">•Медицинские услуги по годовым медицинским программам</p>
        <div class="left-1em">
            <p>
                Данный контракт оптимален для организаций, имеющих определенный бюджет на медицинское обслуживание
                сотрудников. Индивидуальная программа оказания медицинской помощи персоналу разрабатывается исходя из
                Ваших потребностей и финансовых возможностей.
            </p>
        </div>
        <p class="bold">•Медицинские услуги по диагностическим, профилактическим и лечебным программы</p>
        <div class="left-1em">
            <p>
                Вакцинация сотрудников для снижения заболеваемости гриппом в период эпидемии
            </p>
            <p>
                Программы экспресс-диагностики Check-Up
            </p>
            <p>
                Профилактические и лечебные программы
            </p>
        </div>
        <p class="bold">•Программа «Ведение беременности» с выдачей родового сертификата</p>
        <div class="left-1em">
            <p>
                Пациентам гарантирована профессиональная медицинская помощь и эмоциональная поддержка со стороны
                специалистов. Приобретение программы «Ведение беременности» предусматривает выдачу родового сертификата
                и освобождает Пациента от необходимости вставать на учет в женскую консультацию по месту жительства.
                Услуги предоставляются только после предварительного обследования с подтверждением специалистами
                Поликлиники факта физиологически протекающей беременности у Пациента.
            </p>
        </div>
        <p class="bold">•Проведение обязательных медицинских осмотров по приказу №29н</p>
        <div class="left-1em">
            <p>
                Медицинские осмотры проводятся сотрудникам, работающим с вредными и опасными факторами производства
                (согласно Приказу Минздравсоцразвития РФ от 12.04.2011 № 29н Приложение №1 сноски №3, №5 и Приложение
                №2 сноски №1, №3)
            </p>
            <p>
                Наша поликлиника гарантирует обследование в течение одного рабочего дня. При проведении медицинского
                осмотра производится оформление личных медицинских (санитарных) книжек. По результатам периодического
                медицинского осмотра выдается заключение, паспорт здоровья.
            </p>
        </div>
        <p class="bold">•Психотерапевтические программы</p>
        <div class="left-1em">
            <p>
                Проведение эффективных программ профилактики и коррекции синдрома эмоционального выгорания и других
                состояний профессиональной дезадаптации у сотрудников.
            </p>
        </div>
        <div class="divider"></div>
        <h3>КЛИНИКО-ДИАГНОСТИЧЕСКОЕ ОТДЕЛЕНИЕ</h3>
        <p>Отделение создано для комфортного и быстрого медицинского обслуживания пациентов по программам добровольного
            медицинского страхования (ДМС), корпоративных Клиентов и частных лиц.</p>
        <p>Индивидуальный подход к обслуживанию Пациентов, постоянное взаимодействие терапевтов и врачей узких
            специальностей позволяют повысить эффективность лечения.</p>
        <div class="inv-divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/kdo2.jpg" alt="kdo2" width="480" height="315">
            <img src="../../assets/images/staticPages/kdo1.jpg" alt="kdo2" width="300" height="178"
                 style="margin-left: 30px">
        </div>
        <div class="divider"></div>
        <p><strong>Для знакомства с нашими возможностями приглашаем Вас на экскурсию по Поликлинике.</strong></p>
        <p><strong>Для обсуждения даты встречи просим Вас обращаться к нашим сотрудникам:</strong></p>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box"><p>Начальник договорного отдела:</p>
                <p class="bold">Екатерина Львовна
                    Бубнова</p>
                <p>тел. 8 (495) 620-81-29</p></div>
            <div class="box"><p>Экономист договорного отдела:</p>
                <p class="bold">Савенко Алена Александровна</p>
                <p>тел. 8 (495) 620-81-21</p></div>
            <div class="box"><p>Менеджер договорного отдела:</p>
                <p class="bold">Светлана Владимировна
                    Клочкова</p>
                <p>тел. 8 (495) 620-81-21</p></div>
            <div class="box"><p>Профилактические осмотры:</p>
                <p class="bold">Рулева Наталья Петровна</p>
                <p>тел. 8 (495) 620-81-40</p></div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "medicalPrograms",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

</style>
